import React from "react";
import { connect } from "react-redux";
import { Row, Col, Affix, Skeleton } from "antd";

import { interfaceActions } from "../../../../../common/redux/actions";
import * as offersActions from "../../redux/actions/offers";

import progresses from "../../../common/FormProgress/offerPregresses";
import FormOfferCreate from "../../components/OfferCreate/FormOfferCreate";
import * as URLs from "../../../../../common/constants/systemUrls";
import OfferSideBar from "../../components/OfferCreate/sidebar/SideBar";
import showConfirmWindow from "../../../../../common/components/confirmPopup/confirmPopup";
import {
  confirmCloseCreating,
  confirmCreateOffer
} from "../../components/OfferCreate/popup/confirm";

import "./OfferCreate.css";
import { YMaps } from "react-yandex-maps";
import { getRequest } from "../../../Request/redux/actions/requests";

const { setCaption } = interfaceActions;
const { createOffer } = offersActions;

class OfferCreate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      formProgress: [...progresses.default],
      disabledSaveButton: true
    };
    this.forms = [];
  }

  componentDidMount() {
    this.setCaption(true);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (!this.props.request && this.props.location.state.id) {
      this.props.getRequest({ requestId: this.props.location.state.id });
    }

    this.setCaption(this.props.offer !== prevProps.offer && this.props.offer);

    if (
      (this.props.request && this.state.ymaps !== prevState.ymaps) ||
      (!this.state.distance && this.state.duration) ||
      (this.props.request !== prevProps.request && this.state.ymaps)
    ) {
      this.renderRoute();
    }

    if (this.props.updated !== prevProps.updated) {
      this.props.history.push("/executorship/offers/");
    }
  }

  setCaption(flagUpdate = false) {
    if (flagUpdate) {
      let title = "Формирование предложения";
      let breadCrumbs = null;

      if (title) {
        this.props.setCaption({
          enabled: true,
          mainCaption: title,
          breadCrumbs: [
            {
              path: "/" + URLs.CONTROL_PANEL,
              breadcrumbName: "Панель управления"
            },
            { path: "/executorship/offer", breadcrumbName: "Исполнительство" },
            {
              path: "/" + URLs.COMPANY,
              breadcrumbName: breadCrumbs ? breadCrumbs : title
            }
          ]
        });
      }
    }
  }

  getForm = name => {
    if (this.forms.hasOwnProperty(name)) {
      return this.forms[name];
    }
    return false;
  };

  setForm = (name, form) => {
    if (form) {
      return (this.forms[name] = form);
    } else {
      delete this.forms[name];
      return false;
    }
  };

  updateProgress = values => {
    const form = this.getForm("formOfferInfo");
    if (form) {
      let newFormProgress = null;
      let checkAll = true;
      Object.keys(values).forEach(name => {
        this.state.formProgress.forEach((step, index) => {
          if (step.fields.some(fieldName => fieldName === name) && step.check) {
            const fieldsValue = form.getFieldsValue(step.fields);
            const check = step.check(fieldsValue, form);
            if (!newFormProgress)
              newFormProgress = [...this.state.formProgress];
            newFormProgress = [
              ...newFormProgress.slice(0, index),
              {
                ...newFormProgress[index],
                name: step.name,
                completed: check,
                fieldsValue: fieldsValue
              },
              ...newFormProgress.slice(index + 1)
            ];
            if (checkAll && !check) {
              if (step.button !== false) checkAll = false;
            }
          }
        });
      });

      if (newFormProgress) {
        if (checkAll) {
          // Если все изменённые поля успешно прошли проверку
          // делаем полную проверку по всем группам
          // если button = false тогда он не участвует в проверке для кнопки отправки.
          // если в прогрессе нет ключа button то по умолчанию он равен true
          checkAll = newFormProgress.every(({ completed, button = true }) =>
            button ? completed : true
          );
        }
        this.setState({
          formProgress: newFormProgress,
          disabledSaveButton: !checkAll
        });
      }
    }
  };

  handleClickEdit = () => {
    this.setCaption(true);
    this.setIsEditable(true);
  };

  handleSubmit = () => {
    this.formSubmit("formOfferInfo", fieldsValue => {
      showConfirmWindow({
        ...confirmCreateOffer,
        onOk: () => {
          this.props.createOffer({ data: fieldsValue, ymaps: this.state.ymaps });
        }
      });
    });
  };

  formSubmit = (name, cbSubmit) => {
    const form = this.getForm(name);
    if (form) {
      // e.preventDefault();
      form.validateFields((err, fieldsValue) => {
        if (err) {
          return false;
        }
        // Отправка формы
        if (cbSubmit) cbSubmit(fieldsValue);
      });
    } else {
      console.log("Error", name);
    }
  };

  handleCancel = () => {
    showConfirmWindow({
      ...confirmCloseCreating,
      onOk: () => {
        this.props.history.goBack();
      }
    });
  };

  initYmaps = ymaps => {
    this.setState(() => ({
      ymaps: ymaps
    }));
  };

  setIsEditable = boolean => {
    this.setState({ isEditable: boolean });
  };

  renderRoute = () => {
    const markers = this.props.request.routes.map(route => {
      return [route.latitude, route.longitude];
    });

    const multiRoute = new this.state.ymaps.multiRouter.MultiRoute(
      {
        referencePoints: markers,
        params: {
          results: 1
        }
      },
      {
        boundsAutoApply: markers.length > 1
      }
    );

    multiRoute.events.add("update", () => {
      multiRoute.getRoutes().each(route => {
        const properties = route.properties.getAll();
        this.setState(() => ({
          distance: properties.distance.text,
          duration: properties.duration.text,
          vehicleUse: properties.durationInTraffic.text
        }));
      });
    });
  };

  render() {
    const { request, createErrors, clearError, loading } = this.props;
    return (
      <div className="site-wrapper offer-card">
        <Row className="offer-card__form-wrap">
          <Col span={18} className="offer-card__form">
            {loading ? (
              <Skeleton active />
            ) : (
              <FormOfferCreate
                name="formOfferInfo"
                setForm={this.setForm}
                request={request}
                createErrors={createErrors}
                clearError={clearError}
                updateProgress={this.updateProgress}
                isEditable={this.state.isEditable}
                formProgress={this.state.formProgress}
                setIsEditable={this.setIsEditable}
                performers={this.props.performers}
              />
            )}
          </Col>
          <Col span={6} className="offer-card__status offer-card__sidebar">
            <Affix
              offsetTop={18}
              target={() => document.getElementById("mainSheet")}
            >
              <OfferSideBar
                request={this.props.request}
                offer={
                  this.getForm("formOfferInfo") &&
                  this.getForm("formOfferInfo").getFieldsValue()
                }
                disabled={this.state.disabledSaveButton}
                handleClickEdit={this.handleClickEdit}
                handleSubmit={this.handleSubmit}
                progress={this.state.formProgress}
                handleClickClose={this.handleClickClose}
                handleCancel={this.handleCancel}
                setTemplateToForm={this.setTemplateToForm}
                distance={this.state.distance}
                duration={this.state.duration}
                vehicleUse={this.state.vehicleUse}
                {...this.props}
              />
            </Affix>
          </Col>
        </Row>
        <YMaps
          query={{
            apikey: "b6a66b8f-dc2c-4946-a916-0fb0ca680e5a"
          }}
          onApiAvaliable={ymaps => this.initYmaps(ymaps)}
        />
      </div>
    );
  }
}

export default connect(
  state => ({
    request: state.Executorship.Requests.requests.requestById,
    loading: state.Executorship.Requests.requests.loading,
    updated: state.Executorship.Offers.offers.updated,
    performers: state.Common.Filters.performers
  }),
  {
    setCaption,
    createOffer,
    getRequest
  }
)(OfferCreate);
